// TYPES
import { ReducerAction, ReducerActionRotaSP } from 'store/modules/types';
import { IUsuario } from '../consultaPesquisaCidadao/types';
import { ConsultaPesquisaCirg, Types } from './types';

export function consultaPesquisaCirgRequest(
	token: string,
	numeroRg: string,
	usuario: IUsuario,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_REQUEST,
		token,
		payload: {
			numeroRg,
			usuario,
		},
	};
}
export function consultaPesquisaCirgCidadaoSuccess(
	payload: ConsultaPesquisaCirg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_CIDADAO_SUCCESS,
		payload,
	};
}

export function consultaPesquisaCirgCidadaoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_CIDADAO_CLEAR,
		payload: null,
	};
}

export function consultaPesquisaCirgSuccess(
	payload: ConsultaPesquisaCirg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_SUCCESS,
		payload,
	};
}
export function consultaPesquisaCirgFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_FAILURE,
		payload: null,
	};
}

export function consultaPesquisaCirgMaeRequest(
	numeroRg: string,
	usuario: string,
	senha: string,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_MAE_REQUEST,
		payload: {
			numeroRg,
			usuario,
			senha,
		},
	};
}
export function consultaPesquisaCirgMaeSuccess(
	payload: ConsultaPesquisaCirg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_MAE_SUCCESS,
		payload,
	};
}
export function consultaPesquisaCirgMaeFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_MAE_FAILURE,
		payload: null,
	};
}

export function consultaPesquisaCirgClear(): ReducerAction {
	return {
		type: Types.CONSULTA_PESQUISA_CIRG_CLEAR,
		payload: null,
	};
}

export function consultaPesquisaMaeCirgClear(): ReducerAction {
	return {
		type: Types.CONSULTA_PESQUISA_MAE_CIRG_CLEAR,
		payload: null,
	};
}
